'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var raw = require('./raw.js');
var useCurrencyConfig = require('../../hooks/useCurrencyConfig.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const RefundMethods = props => {
  const {
    locale,
    includeCurrency
  } = useCurrencyConfig["default"]();
  return /*#__PURE__*/React__default["default"].createElement(raw["default"], _extends__default["default"]({}, props, {
    locale: locale,
    includeCurrency: includeCurrency
  }));
};

exports.RefundMethodsRaw = raw["default"];
exports.RefundMethods = RefundMethods;
